import React from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// Imported Files
import Home from './Components/Home';
import Dpersonales from './Components/Dpersonales';
import Thanks from './Components/Thanks';
import Carrito from './Components/Carrito';
import { useSelector } from 'react-redux';

function App() {
  const simpleToggler = useSelector(state => state.simpleToggler)
  return (
    <Router>
      { simpleToggler.carrito &&
        <Carrito/>}
      <Switch>
        <Route exact path="/">
          <div className="App">
            <Home/>
          </div>
        </Route>
        <Route path="/datospersonales">
          <Dpersonales/>
        </Route>
        <Route path="/thanks">
          <Thanks/>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
